import PrototypeIcon from '../assets/nav-prototype.svg';
import ChatIcon from '../assets/nav-chat.svg';

interface PrototypeNavLink {
  label: string;
  path: string;
  icon: string;
  children: never[];
  isExpandable: false;
  disabled: boolean;
  activePathPatterns: string[];
}

const prototypeNavLinks: PrototypeNavLink[] = [
  {
    label: 'Prototype 1',
    path: '/prototypes/1',
    icon: PrototypeIcon,
    children: [],
    isExpandable: false,
    disabled: false,
    activePathPatterns: [],
  },
  {
    label: 'Prototype 2',
    path: '/prototypes/2',
    icon: PrototypeIcon,
    children: [],
    isExpandable: false,
    disabled: false,
    activePathPatterns: [],
  },
  {
    label: 'Prototype 3',
    path: '/prototypes/3',
    icon: PrototypeIcon,
    children: [],
    isExpandable: false,
    disabled: false,
    activePathPatterns: [],
  },
];

const sqlChatNavLink: PrototypeNavLink = {
  label: 'SQL Chat',
  path: '/prototypes/4-sql',
  icon: ChatIcon,
  children: [],
  isExpandable: false,
  disabled: false,
  activePathPatterns: [],
};

export { prototypeNavLinks, sqlChatNavLink };
export type { PrototypeNavLink };
